import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'

// import other components within the same project here

import Localization from "../../Localization.jsx"
import { isUnsetCoord } from "../../utils/hotspotGeo.js";

import { Button, Card, Tooltip, ActionIcon, Text, Group, Stack } from '@mantine/core';
import { IconCircleX, IconCircleCheck, IconPlus, IconTrash } from '@tabler/icons-react';
import ListLoadingPlaceholder from '../ListLoadingPlaceholder.jsx';
import Docuement from '../../images/background/docuement.png';

// Roughly the height of a hotspot row (Card padding 10px + a line of text).
const LOADING_ROW_HEIGHT = 46;
const LOADING_ROW_COUNT = 5;

class HotspotListView extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();
    autoBind(this);
  }

  render() {
    // Three states, not two: until the request answers, "this locale has no
    // hotspot" is a claim we cannot make yet.
    const hotspotList = this.props.parent.state.hotspotList;
    const isLoading = this.props.parent.state.hotspotListLoading && hotspotList.length == 0;

    return (
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <div style={{ padding: '12px 16px 8px', flexShrink: 0 }}>
          <Button
            color="brand"
            leftSection={<IconPlus size={18} />}
            onClick={this.props.parent.addHotspot}
          >
            {Localization.strings.NEW_HOTSPOT}
          </Button>
        </div>
        <div style={{ flex: 1, minHeight: 0, overflowY: "auto", padding: "0", fontSize: '16px' }}>
          <If condition={isLoading}>
            <Then>
              <ListLoadingPlaceholder
                count={LOADING_ROW_COUNT}
                height={LOADING_ROW_HEIGHT}
                gap={10}
                style={{ padding: '10px' }}
              />
            </Then>
            <Else>
              <If condition={hotspotList.length > 0}>
                <Then>
                  {hotspotList.map( (row, i) => {
                    return (
                      <Card withBorder key={i} className="margin-std" padding={0}>
                        <Group
                          onClick={()=>this.props.parent.handleHotspotClicked(row)}
                          wrap="nowrap"
                          gap="sm"
                          style={{ cursor: 'pointer', padding: '10px 14px' }}
                        >
                          <If condition={isUnsetCoord(row['lat']) && isUnsetCoord(row['lon'])}>
                            <Then>
                              <Tooltip label={Localization.strings.NOT_POSITIONED}>
                                <IconCircleX size={20} color="#cccccc" />
                              </Tooltip>
                            </Then>
                            <Else>
                              <Tooltip label={Localization.strings.HOTSPOT_HAS_LOCATION}>
                                <IconCircleCheck size={20} color="#ad1179" />
                              </Tooltip>
                            </Else>
                          </If>
                          <Tooltip label={Localization.strings.EDIT}>
                            <Text style={{ flex: 1 }}>{row['name']}</Text>
                          </Tooltip>
                          <Tooltip label={Localization.strings.DELETE}>
                            <ActionIcon
                              variant="subtle"
                              color="gray"
                              onClick={(e)=>{ e.stopPropagation(); this.props.parent.deleteHotspotClicked(row['id']); }}
                            >
                              <IconTrash size={18} color="#bdbdbd" />
                            </ActionIcon>
                          </Tooltip>
                        </Group>
                      </Card>
                    )
                  })}
                </Then>
                <Else>
                  <img style={{display:'block',marginLeft:'auto',marginRight:'auto',height:window.screen.width>1024?'40%':'20%',width:'auto'}} src={Docuement} />
                  <Card className="margin-std padding-std" style={{textAlign:'center'}}>
                    <Stack>
                      {Localization.strings.EMPTY_HOTSPOT_REMINDER}
                    </Stack>
                  </Card>
                </Else>
              </If>
            </Else>
          </If>
        </div>
      </div>
    )
  }
}

export default HotspotListView;
